<!-- Without an explicit placeholder Quill falls back to its English built-in
     ("Insert text here ..."), which surfaced in the otherwise fully Slovenian
     vehicle advertising form. -->
<quill-editor class="editor-container" tabindex="0" [modules]="quillConfiguration"
    placeholder="Vnesite besedilo …"
    i18n-placeholder
    [formControl]="control"></quill-editor>